import {useTranslation} from 'react-i18next'
import {Button} from '@/components/ui/button'

type PaginationBarProps = {
  page: number
  pageSize: number
  total: number
  onPageChange: (page: number) => void
}

export function PaginationBar({page, pageSize, total, onPageChange}: PaginationBarProps) {
  const {t} = useTranslation()
  const start = total === 0 ? 0 : (page - 1) * pageSize + 1
  const end = Math.min(page * pageSize, total)

  return (
    <div className="surface-divider mt-1 flex items-center justify-between gap-3 border-t pt-3 text-sm text-muted-foreground">
      <span>{t('table.showing', {start, end, total})}</span>
      <div className="flex items-center gap-2">
        <Button variant="outline" size="sm" disabled={page <= 1} onClick={() => onPageChange(page - 1)}>
          {t('table.previous')}
        </Button>
        <Button variant="outline" size="sm" disabled={end >= total} onClick={() => onPageChange(page + 1)}>
          {t('table.next')}
        </Button>
      </div>
    </div>
  )
}
